// src/App.tsx
import React from 'react';
import {createRoot} from 'react-dom/client';
import Chat from './components/Chat';
import {useState} from "react";

const App: React.FC = ({assistantId}) => {

  return (
    <div className="App">
      <header className="App-header">
        {/* align center */}
        <h2 id="chatbot-name" style={{textAlign: 'center'}}>Ich beantworte Ihre Fragen!</h2>
      </header>
      <main>
        <Chat
          assistantId = {assistantId}
        />
      </main>
    </div>
  );
};

export default App;

const elem = document.getElementById("chat-bot");

if(elem){
  const assistantId:string = elem.dataset.assistantId;
  const root = createRoot(elem);

  root.render(
    <App
      assistantId = {assistantId}
    />
  );

}
